module.exports = __webpack_public_path__ + "img/4_l_no.451c448f.svg";